var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class CannyLoader {
    get Canny() {
        return window.Canny;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.Canny) {
                return this.Canny;
            }
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = "https://canny.io/sdk.js";
            return new Promise((resolve, reject) => {
                script.onload = () => {
                    resolve(this.Canny);
                };
                script.onerror = (err) => {
                    reject(err);
                };
                document.head.append(script);
            });
        });
    }
}
export { CannyLoader };
